<template>
  <div class="functions-card">
    <button @click="$emit('goShop')">근조 화환</button>

    <button v-show="accountYn" @click="$emit('requestAccountList')">
      조의금
    </button>

    <button @click="$emit('requestShareBugo')">부고 전달</button>
  </div>
</template>

<script>
export default {
  name: "ObituaryBottomButtons",
  props: ["accountYn", "obituaryDetail"]
};
</script>

<style></style>
